import React from "react";

const LocationMap = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M25.358 17.92a11.362 11.362 0 0 0 2.693-4.878c.49-1.844.526-3.79.104-5.654l3.758-1.712a.713.713 0 0 1 .711.067c.105.073.19.172.25.29a.84.84 0 0 1 .089.379V29.2L22.422 34l-9.036-4.8-9.492 4.32a.713.713 0 0 1-.71-.068.785.785 0 0 1-.248-.288.84.84 0 0 1-.09-.378V10l4.71-2.146a11.862 11.862 0 0 0 .264 5.417 11.34 11.34 0 0 0 2.63 4.649l7.454 7.922 7.454-7.92v-.002Zm-2.13-2.262-5.322 5.654-5.327-5.656a8.166 8.166 0 0 1-2.06-4.096 8.466 8.466 0 0 1 .43-4.622 7.916 7.916 0 0 1 2.773-3.589 7.218 7.218 0 0 1 4.183-1.348c1.489 0 2.944.47 4.182 1.348a7.916 7.916 0 0 1 2.774 3.59c.57 1.46.72 3.07.43 4.62a8.167 8.167 0 0 1-2.06 4.097l-.004.002Z"
            fill={fill}
        />
    </svg>
);

export default LocationMap;